// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1BwiJ","author":"Table_author__1_pnl","authorImage":"Table_authorImage__1g0Ry","unreadRow":"Table_unreadRow__2WBdx"};